export const VALIDATION_MESSAGES = {
  email: 'Must be a valid email address',
  invalidChar: 'Invalid characters entered',
  inviteAcceptedOrExpired: 'Your invite link has been accepted or expired',
  passwordResetAcceptedOrExpired: 'Your password reset link has been used or expired',
  notEmpty: 'Must not be empty',
  nameMaxLength: 'Must not be greater than 50 characters',
  nameMultiSpaces: 'Name cannot contain multiple spaces',
  network: 'Huh, something went wrong. Please check your connection and try again',
  notSpaces: 'Must not contain spaces',
  password: 'Enter a password',
  passwordCharacter: 'Must contain at least 1 letter',
  passwordLowercase: 'Must contain at least 1 lower case letter',
  passwordUppercase: 'Must contain at least 1 upper case letter',
  passwordMaxLength: 'Must not be greater than 50 characters',
  passwordMinLength: 'Must be at least 8 characters',
  passwordNumber: 'Must contain at least 1 number',
  passwordSymbol: 'Must contain at least 1 special character',
  startSymbol: 'Must not start with a special character',
};
